/*
 * File: RecentPatients.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays list of recently viewed patients on the dashboard
 */
import React from "react";
import PropTypes from "prop-types";
import { Card, CardContent, Typography, withStyles } from "@material-ui/core";
import SearchButton from "./SearchButton";
import Divider from "@material-ui/core/Divider";
import UILinkList from "components/ui/UILinkList";
import RecentPatientActions from "services/patients/store/RecentPatientActions";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import Preferences from "services/preferences/Store";

const styles = theme => ({
  root: {
    position: "relative",
    marginBottom: theme.spacing(1)
  },
  label: {
    color: theme.palette.common.title,
    fontSize: "1.2em",
    fontWeight: 300,
    paddingBottom: theme.spacing(2.5),
    whiteSpace: "pre-wrap",
    lineHeight: 1.2
  },
  cardContent: {
    padding: theme.spacing(2.5)
  },
  divider: {
    marginLeft: theme.spacing(-2.5),
    marginRight: theme.spacing(-2.5)
  }
});

const RecentPatients = ({ classes }) => {
  const preferencesStore = useStore(Preferences);
  return (
    <Card className={classes.root}>
      <CardContent className={classes.cardContent}>
        <Typography className={classes.label}>
          Recently Viewed Patients
        </Typography>
        <Divider className={classes.divider} />
        <UILinkList links={RecentPatientActions.uiLinks(preferencesStore)} />
        <SearchButton />
      </CardContent>
    </Card>
  );
};

RecentPatients.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(observer(RecentPatients));
